import { OAuthExternalCallbackPage } from "src/features/integrations/sources/oauth/OAuthExternalCallbackPage.js";

export const PowerofficeExternalCallbackPage = () => {
	return <OAuthExternalCallbackPage />;
};
